<template>
<v-container>
 
 <v-banner single-line>
    <v-icon
      slot="icon"
      color="pink"
      size="36"
    >
      mdi-upload
    </v-icon>
    Student Uploader
    <template v-slot:actions>
      
<v-btn
  elevation="2"
  v-on:click="goToConciergePad"
  color="pink"
  outlined
>Logout
      <v-icon
        right
        dark
      >
        mdi-exit-to-app
      </v-icon>
      </v-btn>
    </template>
  </v-banner>

           <v-progress-linear
           v-if="doProgress"
      indeterminate
      height="25"
      color="yellow darken-2"
    ></v-progress-linear>



      <v-chip
      class="ma-2"
      color="pink"
      text-color="white"
    >
      <v-icon left>
        mdi-alert
      </v-icon>
       Upload a csv and and map the columns
    </v-chip>

      <vue-csv-import
     v-if="importVisible"
      url="/"
      :canIgnore="true"
    v-model="csv"
    :map-fields="['First Name', 'Last Name','DOB','Student ID','Grade','Homeroom','Homeroom Email','Parent Email 1','Parent Phone 1','Parent Email 2','Parent Phone 2','Hanger ID']">

    <template slot="hasHeaders" slot-scope="{headers, toggle}" canIgnore='true'>
 
        <label>
            <input type="checkbox" id="hasHeaders" :value="headers" @change="toggle">
            File has Headers


              <v-checkbox
              v-model="selected"
              label="Refresh Carline Data"
              color="indigo"
              :value="selected"
            ></v-checkbox>


        </label>


          
        
   
    </template>

    <template slot="error" canIgnore='true'>
        File type is invalid
    </template>

    <template slot="thead" canIgnore='true' ignoreOptionText   >
        <tr     >
            <th>ConciergePad Fields</th>
            <th>Columns in Upload Doc</th>
        </tr>
    </template>


    <template slot="submit" slot-scope="{submit}" :canIgnore="true">
        

          <v-btn
       @click="submit"
  elevation="2"
  v-on:click="goToUpload"
  color="success"
>Upload</v-btn>

    <v-progress-linear
           v-if="doProgress"
      indeterminate
      height="25"
      color="yellow darken-2"
    ></v-progress-linear>


    </template>
</vue-csv-import>
          

     
     <!--<div class="card" v-if="csv" canIgnore='true'>
                <div class="card-body">
                  <pre>
                      {{csv}}
                  </pre>
                </div>
              </div>-->

            
<div>
<spacer></spacer>
<spacer></spacer>
<spacer></spacer>
<spacer></spacer>
<spacer></spacer>
     </div>

    </v-container>

     




    




 

</template>


<script>

  import axios from 'axios';
  import { uuid } from 'vue-uuid';
  import { VueCsvImport } from 'vue-csv-import';

  export default {
    components: { VueCsvImport },
    data: () => ({
      uuid: uuid.v1(),
      importVisible: true,
      file:'',
      selected: 'Y',
      csv:[],
      headers: true,
      userName: '',
      doProgress: false,
      passwordAlert: false,
      removeButton: true,
      message: '',
      canIgnore: true,
      alert: false,
      pId: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      userId: 1,
      items: [],
      name: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      
      this.pId = this.$route.query.id;

      this.companyName = this.$route.query.uuid;

      this.userName = this.$route.query.username;

      this.sendMessage(this.userName);

      console.log(this.pId);

      console.log(this.$route.query);

  },
  watch: {
    email(email) {
      this.$intercom.update({ email });
    },
  },

    methods: {


      sendMessage:function(userName) {

      axios.get('https://api.conciergepadedu.com/api/Rosters/SendMessage/' +  userName).then(response => {

      if (response.data.error) {

        console.log(response.data.error);

      } else {

        console.log(response.data);
        

        //successful
       

        console.log("////////////////////////////////////");
        console.log(this.items.primarY_ACCOUNT);

        




        }

        }).catch(error => {

            console.log(error.response)

          

        });

    },
    goToConciergePad: function() {

       console.log('Logging out')

      

       window.location.href = "https://www.conciergepadedu.com/login";


   },
    toggle(val) {

        console.log(val);
    },
  
    showCsv() {
console.log(this.csv);
    },
    goToUpload() {

        if (Object.keys(this.csv).length == 0) {

            this.$alert("Upload is empty","Upload Error","error");

        } else {

        this.$confirm("Are you sure you want to upload data?").then(() => {
            
            this.getCsvFile();
        });

        }

        

    },
    getCsvFile() {

        this.doProgress = true;

        var errors = "N";
        var data = [];

    if (this.csv.length > 0) {

        for(var i in this.csv) {

           if (this.csv[i]["Student ID"] == null || this.csv[i]["Student ID"]  ==  "" || this.csv[i]["Student ID"].length == 0) {
               console.log("student ID is null")
           }
           else if (this.companyName == null || this.companyName == "" || this.companyName.legnth == 0) {

               console.log("Company Name is null")
               errors = "Company name is blank"
           }
           else if (this.csv[i]["DOB"] == null || this.csv[i]["DOB"]  ==  "" || this.csv[i]["DOB"].length == 0) {

               console.log("DOB is null")
               errors = "Date of Birth error"
           }
          
           else {

            var myElement = {
               
                firstName: this.csv[i]["First Name"],
                lastName: this.csv[i]["Last Name"],
                dob: this.csv[i]["DOB"],
                studentId: this.csv[i]["Student ID"],
                grade: this.csv[i]["Grade"],
                homeroom: this.csv[i]["Homeroom"],
                homeroomEmail: this.csv[i]["Homeroom Email"],
                de1: this.csv[i]["Parent Email 1"],
                dp1: this.csv[i]["Parent Phone 1"],
                de2: this.csv[i]["Parent Email 2"],
                dp2: this.csv[i]["Parent Phone 2"],
                hangerId: this.csv[i]["Hanger ID"],
                companyName: this.companyName,
                refreshCarline: this.selected
                }

            data.push(myElement);
           }

        }

        this.csv = '';
        this.csv = data;

        



         } else {

            errors   = "Student Data is empty"
        }

        

     if (Object.keys(data).length == 0 && errors == "N") {

                console.log("Student Data is empty or not complete, please map columns")
                errors = "Student Data is empty or not complete, please map columns"

           }

    if (errors == "N") {

        const hasDuplicate = (arrayObj, colName) => {
        var hash = Object.create(null);
        return arrayObj.some((arr) => {
            return arr[colName] && (hash[arr[colName]] || !(hash[arr[colName]] = true));
            });
        };

        var isDuplicate = hasDuplicate(this.csv, "Student ID");
        console.log(isDuplicate);

      if (isDuplicate == false) {

          console.log("Post to API");

          this.postStudent(this.csv);

      } 

    } else {

            this.doProgress = false;

            this.$alert(errors,"Upload Error","error");

     }


    },


    postStudent(studetArray) {


    this.doProgress = true;



    axios.post('https://api.conciergepadedu.com/api/Rosters/PostStudent',studetArray).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

           this.doProgress = false;
           this.importVisible = true;

      } else {

      console.log('success', response.data);

      this.csv = [];

        if (response.data == "success") {

            this.importVisible = false;

            this.$alert("File was uploaded successfully","Added Students","success");

        } else {

            this.$alert(response.data,"Added Students","error");
        }
      


        //this.$alert("No Household ID detected","Add","error");
        
    this.doProgress = false;
    this.importVisible = true;
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);

            this.doProgress = false;
            this.importVisible = true;


        });

 

  },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>